import extend from './extend';
export var ProjectStatus;
(function (ProjectStatus) {
    ProjectStatus[ProjectStatus["Inactive"] = 1] = "Inactive";
    ProjectStatus[ProjectStatus["Active"] = 2] = "Active";
    ProjectStatus[ProjectStatus["Archived"] = 3] = "Archived";
    ProjectStatus[ProjectStatus["Draft"] = 4] = "Draft";
})(ProjectStatus || (ProjectStatus = {}));
export var ProjectType;
(function (ProjectType) {
    ProjectType[ProjectType["Survey"] = 1] = "Survey";
    ProjectType[ProjectType["Call"] = 2] = "Call";
    ProjectType[ProjectType["SurveyCall"] = 3] = "SurveyCall";
})(ProjectType || (ProjectType = {}));
export const ProjectTypeMap = extend(new Map([
    [ProjectType.Call, { name: 'Interviews' }],
    [ProjectType.Survey, { name: 'Online Survey' }],
    [ProjectType.SurveyCall, { name: 'Screener + Interviews' }],
]));
export var ProjectSubtype;
(function (ProjectSubtype) {
    ProjectSubtype[ProjectSubtype["OpportunityAssessment"] = 1] = "OpportunityAssessment";
    ProjectSubtype[ProjectSubtype["ConceptTesting"] = 2] = "ConceptTesting";
    ProjectSubtype[ProjectSubtype["MessageTesting"] = 3] = "MessageTesting";
    ProjectSubtype[ProjectSubtype["PositioningTesting"] = 4] = "PositioningTesting";
    ProjectSubtype[ProjectSubtype["VisualAidTesting"] = 5] = "VisualAidTesting";
    ProjectSubtype[ProjectSubtype["PatientJourney"] = 6] = "PatientJourney";
    ProjectSubtype[ProjectSubtype["JourneyTesting"] = 7] = "JourneyTesting";
    ProjectSubtype[ProjectSubtype["Other"] = 8] = "Other";
    ProjectSubtype[ProjectSubtype["Segmentation"] = 9] = "Segmentation";
    ProjectSubtype[ProjectSubtype["DriversAndBarriers"] = 10] = "DriversAndBarriers";
    ProjectSubtype[ProjectSubtype["DemandAssessment"] = 11] = "DemandAssessment";
    ProjectSubtype[ProjectSubtype["CurrentLandscape"] = 12] = "CurrentLandscape";
    /* AdverseEventsManagement = 13, */
})(ProjectSubtype || (ProjectSubtype = {}));
export var AudienceType;
(function (AudienceType) {
    AudienceType[AudienceType["Payer"] = 1] = "Payer";
    AudienceType[AudienceType["Patient"] = 2] = "Patient";
    AudienceType[AudienceType["HealthcareProfessional"] = 3] = "HealthcareProfessional";
    AudienceType[AudienceType["HealthcarePractitioner"] = 4] = "HealthcarePractitioner";
    AudienceType[AudienceType["Other"] = 5] = "Other";
})(AudienceType || (AudienceType = {}));
export var ProjectGoalType;
(function (ProjectGoalType) {
    ProjectGoalType[ProjectGoalType["Call"] = 1] = "Call";
    ProjectGoalType[ProjectGoalType["Survey"] = 2] = "Survey";
})(ProjectGoalType || (ProjectGoalType = {}));
export * from './project.action';
export * from './project.user';
